import styled from 'styled-components';

import { LiveEventSessionCard } from '@/pages/LiveEvent/LiveEventSessionCard/LiveEventSessionCard';
import { useLiveEventLocations } from '@/pages/LiveEvent/LiveEventLocationsContext';

const RootStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const TitleStyled = styled.div`
  ${({ theme }) => theme.typography.title4};
  color: ${({ theme }) => theme.colors.neutral.onBackground};
`;

const SessionsListStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const getCardVariant = ({
  locationId,
  activeId,
  selectedId,
  hasEnded,
}: {
  locationId: number;
  activeId?: number;
  selectedId: number | null;
  hasEnded: boolean;
}): 'default' | 'selected' | 'checked' | 'disabled' => {
  if (typeof activeId === 'number' && locationId === activeId) return 'checked';
  if (selectedId !== null && locationId === selectedId) return 'selected';
  if (hasEnded) return 'disabled';
  return 'default';
};

type LiveEventSessionPickerProps = {
  selectedSessionId: number | null;
  activeSessionId?: number;
  setSelectedSessionId: (sessionId: number) => void;
};

export const LiveEventSessionPicker = ({
  selectedSessionId,
  activeSessionId,
  setSelectedSessionId,
}: LiveEventSessionPickerProps): JSX.Element | null => {
  const { locations, getLocationNameById } = useLiveEventLocations();

  if (!locations?.length) return null;

  return (
    <RootStyled>
      <TitleStyled>Choose session</TitleStyled>
      <SessionsListStyled>
        {locations.map((location) => {
          const name = getLocationNameById(location.id);
          const type = location.type;
          const variant = getCardVariant({
            locationId: location.id,
            activeId: activeSessionId,
            selectedId: selectedSessionId,
            hasEnded: location.hasEnded,
          });

          return (
            <LiveEventSessionCard
              key={location.id}
              name={name}
              date={location.dateWithoutWeekDay}
              type={type}
              variant={variant}
              onClick={() => setSelectedSessionId(location.id)}
            />
          );
        })}
      </SessionsListStyled>
    </RootStyled>
  );
};
